/** The CTH01's LoRaWAN application port, fixed by the device. */
export const CTH01_APPLICATION_PORT = 85;

/**
 * What the operator still has to write to a freshly provisioned hub in ToolBox. The Bluetooth password is
 * generated in the Provision CTH01 form and stored nowhere else; the LoRaWAN settings are also on the hub's
 * Details tab, but belong next to it so the ToolBox session needs one screen.
 */
export interface Cth01ProvisionHandoff {
  bluetoothPassword: string;
  appEUI: string;
  appKey: string;
  frequencyPlan: string;
}

/**
 * Handoffs waiting to be shown, by hub id. In memory on purpose: the Configuration tab unmounts on every tab
 * switch and reads this again on return, so the notice stays until the operator closes it, and nothing with
 * the password in it lands in browser history or session restore. A reload clears it, and so does signing out
 * (AuthContext.logout calls forgetAllCth01ProvisionHandoffs): the next operator on this tab must not inherit
 * the previous one's password.
 */
const pending = new Map<string, Cth01ProvisionHandoff>();

export function rememberCth01ProvisionHandoff(deviceId: string, handoff: Cth01ProvisionHandoff): void {
  pending.set(deviceId, handoff);
}

export function readCth01ProvisionHandoff(deviceId: string): Cth01ProvisionHandoff | undefined {
  return pending.get(deviceId);
}

export function forgetCth01ProvisionHandoff(deviceId: string): void {
  pending.delete(deviceId);
}

/** Sign-out: nothing from the previous session survives it. */
export function forgetAllCth01ProvisionHandoffs(): void {
  pending.clear();
}
